import { render, staticRenderFns } from "./ModalRegisterCard.vue?vue&type=template&id=0f058dc4&scoped=true"
import script from "./ModalRegisterCard.vue?vue&type=script&lang=js"
export * from "./ModalRegisterCard.vue?vue&type=script&lang=js"
import style0 from "./ModalRegisterCard.vue?vue&type=style&index=0&id=0f058dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f058dc4",
  null
  
)

export default component.exports